'use client';
import React, { createContext, useContext, useState } from 'react';

// Create a context for showSetting
const ShowSettingContext = createContext();

// Export a custom hook for easier access
export const useShowSetting = () => useContext(ShowSettingContext);

// Create a Provider component
export const ShowSettingProvider = ({children,getMenu, getSettings,  initialBlogData = [], getScrollData, initialProjectData=[], initialIndustryData=[], initialImpactData=[]}) => {
    const [getBlogData, setBlogData] = useState(initialBlogData); // Store blog data in state
    const [getProjectData, setProjectData] = useState(initialProjectData); // Store scroll data in state
    const [getIndustryData, setIndustryData] = useState(initialIndustryData); // Store scroll data in state
    const [getImpactData, setImpactData] = useState(initialImpactData); // Store scroll data in state
    return (
        <ShowSettingContext.Provider
            value={{getMenu, getSettings, getImpactData, setImpactData, getBlogData, getIndustryData, setIndustryData, setBlogData,getScrollData,getProjectData, setProjectData}}>
            {children}
        </ShowSettingContext.Provider>
    );
};
